import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import PlayCircleFilled from 'material-ui-icons/PlayCircleFilled';
import InPersonDialog from './InPersonDialog';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
    fontSize: 1.2 + 'rem'
  },
  inlineBlock: {
    display: 'inline-block',
    margin: theme.spacing.unit
  }
});

class HostSigningButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showHostContent: false,
      showSigningContent: false,
      showCancelContent: false
    };
    this.onStartHosting = this.onStartHosting.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onActivateCancelContent = this.onActivateCancelContent.bind(this);
  }

  handleOpen() {
    this.setState({ open: true });
    this.setState({ showHostContent: true });
    this.setState({ showSigningContent: false });
    this.setState({ showCancelContent: false });
  }

  handleClose() {
    this.setState({ open: false });
  }

  onStartHosting() {
    this.setState({ showHostContent: false });
    this.setState({ showSigningContent: true });
  }

  onActivateCancelContent() {
    this.setState({ showSigningContent: false });
    this.setState({ showCancelContent: true });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.inlineBlock}>
        <Button
          variant="raised"
          size="small"
          color="primary"
          onClick={this.handleOpen}
        >
          <PlayCircleFilled className={classes.leftIcon} />
          Start Hosting
        </Button>
        <InPersonDialog
          participant={this.props.document.nextParticipant}
          document={this.props.document}
          open={this.state.open}
          onStartHosting={this.onStartHosting}
          onStartSigning={this.onStartSigning}
          onActivateCancelContent={this.onActivateCancelContent}
          showHostContent={this.state.showHostContent}
          showSigningContent={this.state.showSigningContent}
          showCancelContent={this.state.showCancelContent}
          onClose={this.handleClose}
        />
      </div>
    );
  }
}

HostSigningButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(HostSigningButton);



// WEBPACK FOOTER //
// ./src/components/HostSigningButton.js